<script setup lang="ts">
import { useDisplay } from 'vuetify'
import AddStudentsImg from '@images/dashboard/add-students.png'
import AddStudentsIcon from '@images/dashboard/add-students.svg'

const { xlAndUp } = useDisplay()
</script>

<template>
  <VCard class="elevation-5 flex-grow-1">
    <VRow
      no-gutters
      class="h-100"
    >
      <VCol
        cols="3"
        sm="6"
      >
        <div class="bg-image__stretch-to-right my-2 ml-2">
          <VImg
            :src="AddStudentsImg"
            height="100%"
            min-height="250"
            :position="xlAndUp ? 'left top' : ''"
            cover
          />
        </div>
      </VCol>
      <VCol
        cols="9"
        sm="6"
        class="pa-4 d-flex flex-column justify-space-between"
      >
        <div class="d-flex flex-fill">
          <div class="d-flex flex-column justify-center">
            <h4 class="mt-3">
              {{ $t('pages.dashboard.add_students_card_header') }}
            </h4>
            <p class="text-body-2 my-3">
              {{ $t('pages.dashboard.add_students_card_text') }}
            </p>
          </div>
        </div>
        <div class="text-right">
          <VBtn
            :to="{ name: 'students.add-options' }"
            class="submit-btn"
            tonal
            rounded="xl"
          >
            <template #prepend>
              <VImg
                :src="AddStudentsIcon"
                width="15"
              />
            </template>
            {{ $t('pages.dashboard.add_students_card_btn') }}
          </VBtn>
        </div>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss" scoped>
.bg-image__stretch-to-right {
  width: calc(100% + 40px);
}
</style>
